export default __webpack_public_path__ + "static/media/toyota.9947d646.png";